export default __webpack_public_path__ + "a4e8a2088eb96c1da21304e48830fdd0.svg";